import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import useSEO from "@/hooks/useSEO";

export default function NotFound() {
    useSEO({
        title: "Page Not Found",
        description: "The page you are looking for does not exist on LÜVYN.",
    });

    return (
        <div className="relative min-h-screen overflow-x-hidden flex flex-col">
            <div className="grain" />
            <Header />
            <main className="flex-grow flex items-center justify-center pt-32 pb-20">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
                    <h1 className="font-display text-[15vw] sm:text-[10vw] lg:text-[12rem] leading-[0.82] tracking-tighter">
                        404 ·{" "}
                        <span className="font-italic-serif text-[var(--hot)]">
                            Lost.
                        </span>
                    </h1>
                    <p className="mt-8 text-xl text-[var(--ink-soft)] max-w-lg mx-auto leading-relaxed">
                        This page doesn't exist. Maybe it was ghosted.
                    </p>
                    <div className="mt-12">
                        <a
                            href="/"
                            className="hot-button inline-flex items-center gap-3 px-7 py-4 text-sm font-mono uppercase tracking-[0.18em] border-2 border-[var(--ink)]"
                        >
                            Back to safety
                        </a>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
